import axios from 'utils/axios-interceptor';
import { API_URL } from '../constants/config';
import Log from 'lib/Log';

export const fetchAnalyticsScript = async (payload) => {
  try {
    return await axios.post(`${API_URL}/analytic-scripts`, payload, {});
  } catch (err) {
    Log.error(err);
  }
};
